import React, { createContext, useContext, useState } from "react";

const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
  const [handlePay, setHandlePay] = useState(null);

  return <PaymentContext.Provider value={{ handlePay, setHandlePay }}>{children}</PaymentContext.Provider>;
};

export const usePayment = () => useContext(PaymentContext);
